import React, {useState} from 'react';
import './image-info.css'

const ImageInfo = ({isImageOnTheLeft=true, title="Add Title", text="Add Text", image="" })=> {

    const formattedText = text?.split('\n')?.map((line, index) => {
        return (
            // <p key={index}>
            <p className='italic' key={index}>
                {line}
            </p>
        )
    }) 

    return (
        <div className="image-info-wrapper">
            <div className="row">
                {isImageOnTheLeft ? 
                    <div className="info-picture-wrapper center col-sm-12 col-md-6">
                        <img className="info-picture popout-slow" src={image} alt="headshot" />
                    </div> : ""
                }

                <div className="image-info-detail center col-sm-12 col-md-6">
                    <h3>{title}</h3>
                    {formattedText}
                </div>

                {!isImageOnTheLeft ? 
                    <div className="info-picture-wrapper center col-sm-12 col-md-6">
                        <img className="info-picture popout-slow" src={image} alt="headshot" />
                    </div> : ""
                }
            </div>
        </div>
    )
}

export default ImageInfo;
